/** Unidades sugeridas no campo de quantidade (as mesmas da tela anterior). */
export const UNIDADES_QUANTIDADE = [
  'comprimidos',
  'cápsulas',
  'drágeas',
  'cartelas',
  'caixas',
  'frascos',
  'ampolas',
  'flaconetes',
  'sachês',
  'frascos-ampola',
  'seringas preenchidas',
  'bisnagas',
  'potes',
  'patches transdérmicos',
  'aerossóis',
  'sprays',
  'supositórios',
]

/** Sugere unidade quando o texto termina num número ("2", "1 caixa e 2"). */
export const deveSugerirUnidade = (texto: string) => /(^|\s)\d+$/.test(texto)

/** "2" + "caixas" → "2 caixas"; mantém o que vinha antes do número. */
export const completarComUnidade = (texto: string, unidade: string) => `${texto} ${unidade}`
